import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { handleError } from '../shared/Functions';
import { UserUtilityVService } from '../../services/keymaster';
import { Button, CircularProgress, TextField } from '@material-ui/core';

export const Reset = ({errorToast, successToast}) => {
    let history = useHistory();
    const { resetId } = useParams<{ resetId: string }>();
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [model, setModel] = useState<any>()

    useEffect(() => setModel({
        ...model,
        resetId: resetId
    }), [resetId])// eslint-disable-line react-hooks/exhaustive-deps
    
    const updateForm = event => {
        let name = event.target.name;
        let value = event.target.value === "" ? null : event.target.value;

        if (event.target.type === "checkbox") {
            name = event.target.id;
            value = event.target.checked
        }
        setModel({
            ...model,
            [name]: value
        })
    }

    const submit = () => {
        setSubmitting(true)
        UserUtilityVService.userUtilityVPasswordResetAdmin(model)
            .then(x => {
                successToast("Successfully changed your password.")
                history.push('/');
            })
            .catch(x =>
            {
                setSubmitting(false)
                errorToast(handleError(x))
            })
    }

    return <>
        <form style={{backgroundColor:"white", padding:"5px", width: "500px", margin: "auto", borderRadius:"15px"}}>
            <TextField
                disabled={submitting}
                onChange={updateForm}
                margin="normal"
                name="newPassword"
                label="New Password"
                type="password"
                value={model?.newPassword ?? ""}
                fullWidth
            />
            <TextField
                disabled={submitting}
                onChange={updateForm}
                margin="normal"
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                value={model?.confirmPassword ?? ""}
                fullWidth
            />
            <Button
                disabled={submitting}
                id="submit"
                size='large'
                type="submit"
                color="primary"
                variant='contained'
                onClick={submit}>
                {submitting ?
                    <>
                        <CircularProgress color="primary" />
                    </> : 'Update Password'}
            </Button>
        </form>
    </>
}